import React, { useEffect, useState } from "react";
import { IoSunny } from "react-icons/io5";
import { FaMoon } from "react-icons/fa";

const DarkModeSwitch = () => {
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem("themePartnerAdmin") === "dark";
  });

  useEffect(() => {
    if (isDark) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
    localStorage.setItem("themePartnerAdmin", isDark ? "dark" : "light");
  }, [isDark]);

  const toggleDarkMode = () => {
    setIsDark(!isDark);
  };

  return (
    <div className="flex items-center gap-3">
      <IoSunny className="text-primary text-xl" />
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={isDark}
          onChange={toggleDarkMode}
          className="sr-only peer"
        />
        <div className="w-11 h-6 bg-gray-300 rounded-full border border-gray-400/50 peer-checked:bg-primary peer-focus:ring-2 peer-focus:ring-primary/50 peer-focus:border-primary transition-all duration-300"></div>
        <div className="absolute left-[2px] top-[2px] bg-white w-5 h-5 rounded-full shadow transition-all duration-300 peer-checked:translate-x-[22px]"></div>
      </label>

      <FaMoon className="text-primary text-xl" />
    </div>
  );
};

export default DarkModeSwitch;
